(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["forma-bundles"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var grid = document.querySelector('[data-forma-bundles]');
    if(!grid) return;
    var cards = grid.querySelectorAll('.forma-bd__card');
    var elTitle = document.querySelector('[data-bd-title]');
    var elTotal = document.querySelector('[data-bd-total]');
    var elCompare = document.querySelector('[data-bd-compare]');
    var elSave = document.querySelector('[data-bd-save]');
    var elSupply = document.querySelector('[data-bd-supply]');
    var selectedQty = '1';
    function select(card){
      cards.forEach(function(x){ x.classList.remove('is-selected'); });
      card.classList.add('is-selected');
      selectedQty = card.dataset.qty;
      if(elTitle) elTitle.textContent = card.dataset.title;
      if(elTotal) elTotal.textContent = card.dataset.total;
      if(elCompare){ elCompare.textContent = card.dataset.compare || ''; elCompare.style.display = card.dataset.compare ? '' : 'none'; }
      if(elSave){ elSave.textContent = card.dataset.save || ''; elSave.style.display = card.dataset.save ? '' : 'none'; }
      if(elSupply) elSupply.textContent = card.dataset.supply || '';
    }
    cards.forEach(function(c){ c.addEventListener('click', function(){ select(c); }); });
    var def = grid.querySelector('[data-default]') || cards[0];
    if(def) select(def);
    var add = document.querySelector('[data-forma-bundle-add]');
    if(add) add.addEventListener('click', function(){
      var form = document.querySelector('product-form form') || document.querySelector('form[action*="/cart/add"]');
      if(!form) return;
      var q = form.querySelector('input[name="quantity"]');
      if(q){ q.value = selectedQty; q.dispatchEvent(new Event('change', {bubbles:true})); }
      var submit = form.querySelector('[type="submit"], [name="add"]');
      if(submit){ submit.click(); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["forma-checkout-block"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var btn = document.querySelector('[data-forma-cb-add]');
    if(!btn) return;
    var label = btn.querySelector('[data-cb-label]');
    var base = label ? label.textContent : 'Add to cart';
    var qty = '1';
    function sync(){
      var sel = document.querySelector('.forma-bd__card.is-selected');
      if(sel){ qty = sel.dataset.qty || '1'; if(label && sel.dataset.total){ label.textContent = base.replace(/·.*$/, '').trim() + ' · ' + sel.dataset.total; } }
    }
    document.querySelectorAll('.forma-bd__card').forEach(function(c){ c.addEventListener('click', sync); });
    sync();
    btn.addEventListener('click', function(){
      var sel = document.querySelector('.forma-bd__card.is-selected');
      var variant = sel && sel.dataset.variant;
      if(!variant || variant === '0') return;
      btn.disabled = true;
      var addUrl = btn.getAttribute('data-cart-add-url') || '/cart/add.js';
      var checkoutUrl = btn.getAttribute('data-checkout-url') || '/checkout';
      fetch(addUrl, { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ id: parseInt(variant, 10), quantity: 1 }) })
        .then(function(r){ return r.json(); })
        .then(function(){ window.location.href = checkoutUrl; })
        .catch(function(){ btn.disabled = false; });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["forma-gallery-loop"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var gallery = document.querySelector('media-gallery');
      if (!gallery) return;
      var list = gallery.querySelector('.product__media-list');
      var prev = gallery.querySelector('.slider-button--prev');
      var next = gallery.querySelector('.slider-button--next');
      if (!list || !prev || !next) return;
      var slides = list.querySelectorAll('.product__media-item');
      if (slides.length < 2) return;

      function base() { return slides[0].offsetLeft; }
      function currentIndex() {
        var sl = list.scrollLeft, b = base(), best = 0, bestD = Infinity;
        slides.forEach(function (s, i) {
          var d = Math.abs((s.offsetLeft - b) - sl);
          if (d < bestD) { bestD = d; best = i; }
        });
        return best;
      }
      function goTo(i) {
        list.scrollTo({ left: slides[i].offsetLeft - base(), behavior: 'smooth' });
      }
      function enable() {
        prev.removeAttribute('disabled');
        next.removeAttribute('disabled');
      }
      // Dawn re-adds `disabled` at the ends on scroll — keep them enabled.
      var mo = new MutationObserver(enable);
      mo.observe(prev, { attributes: true, attributeFilter: ['disabled'] });
      mo.observe(next, { attributes: true, attributeFilter: ['disabled'] });
      enable();

      next.addEventListener('click', function (e) {
        e.stopImmediatePropagation(); e.preventDefault();
        goTo((currentIndex() + 1) % slides.length);
      }, true);
      prev.addEventListener('click', function (e) {
        e.stopImmediatePropagation(); e.preventDefault();
        goTo((currentIndex() - 1 + slides.length) % slides.length);
      }, true);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["forma-guarantee-cta"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.addEventListener('click', function(e){
      var btn = e.target.closest('[data-forma-scroll-atc]');
      if(!btn) return;
      var target = document.getElementById('forma-buy');
      if(!target) return; // no ATC on this page -> follow href normally
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["forma-mg-chart"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var cta = document.querySelector('[data-forma-mg-cta]');
    if(!cta) return;
    var priceEl = cta.querySelector('[data-mg-price]');
    function selected(){ return document.querySelector('.forma-bd__card.is-selected'); }
    function sync(){
      var sel = selected();
      if(sel && priceEl && sel.dataset.total){ priceEl.textContent = ' · ' + sel.dataset.total; }
    }
    document.querySelectorAll('.forma-bd__card').forEach(function(c){ c.addEventListener('click', function(){ setTimeout(sync, 0); }); });
    sync();
    cta.addEventListener('click', function(e){
      var sel = selected();
      var variant = sel && sel.dataset.variant;
      if(!variant || variant === '0') return; // no bundle on page -> follow href
      e.preventDefault();
      cta.style.pointerEvents = 'none';
      var addUrl = cta.getAttribute('data-cart-add-url') || '/cart/add.js';
      var checkoutUrl = cta.getAttribute('data-checkout-url') || '/checkout';
      fetch(addUrl, { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ id: parseInt(variant, 10), quantity: 1 }) })
        .then(function(r){ return r.json(); })
        .then(function(){ window.location.href = checkoutUrl; })
        .catch(function(){ cta.style.pointerEvents = ''; });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["forma-mushrooms"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var root = document.querySelector('[data-forma-ms]');
    if(!root) return;
    var modal = root.querySelector('[data-forma-ms-modal]');
    var mImg = modal.querySelector('[data-ms-img]');
    var mName = modal.querySelector('[data-ms-name]');
    var mDesc = modal.querySelector('[data-ms-desc]');
    var mDose = modal.querySelector('[data-ms-dose]');
    function open(card){
      mImg.src = card.dataset.img; mImg.alt = card.dataset.name;
      mName.textContent = card.dataset.name;
      mDesc.textContent = card.dataset.desc || card.dataset.benefit || '';
      if(card.dataset.dose){ mDose.textContent = card.dataset.dose; mDose.style.display=''; } else { mDose.style.display='none'; }
      modal.hidden = false; document.body.style.overflow='hidden';
    }
    function close(){ modal.hidden = true; document.body.style.overflow=''; }
    // category tabs
    var tabs = root.querySelectorAll('.forma-ms__tab');
    var cards = root.querySelectorAll('.forma-ms__card');
    function showCat(cat){
      tabs.forEach(function(t){ t.classList.toggle('is-active', t.dataset.cat === cat); });
      cards.forEach(function(c){ c.style.display = (c.dataset.cat === cat) ? '' : 'none'; });
    }
    tabs.forEach(function(t){ t.addEventListener('click', function(){ showCat(t.dataset.cat); }); });
    if (tabs.length) showCat(tabs[0].dataset.cat);
    root.querySelectorAll('.forma-ms__card').forEach(function(c){ c.addEventListener('click', function(){ open(c); }); });
    modal.querySelectorAll('[data-forma-ms-close]').forEach(function(el){ el.addEventListener('click', close); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape' && !modal.hidden) close(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["forma-pdp-columns"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function place() {
      var info = document.querySelector('.product__info-wrapper');
      if (!info) return;
      ['.forma-bd', '.forma-cb', '.forma-acc'].forEach(function (sel) {
        var el = document.querySelector(sel);
        var sec = el ? el.closest('.shopify-section') : null;
        if (sec && sec.parentNode !== info) { info.appendChild(sec); sec.classList.add('forma-in-info'); }
      });
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', place); }
    else { place(); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["forma-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bar = document.getElementById('forma-satc');
    if (!bar) return;
    bar.hidden = false;
    var trigger = document.querySelector('.product-form') || document.querySelector('main');
    function toggle() {
      var show = window.scrollY > 600;
      if (trigger && trigger.getBoundingClientRect) {
        var r = trigger.getBoundingClientRect();
        show = r.bottom < 80 || (window.scrollY > 600 && r.top > window.innerHeight);
      }
      bar.classList.toggle('is-visible', show);
    }
    window.addEventListener('scroll', toggle, { passive: true });
    window.addEventListener('resize', toggle);
    toggle();
    var nowEl = bar.querySelector('[data-satc-now]');
    var wasEl = bar.querySelector('[data-satc-was]');
    function syncPrice() {
      var sel = document.querySelector('.forma-bd__card.is-selected');
      if (!sel) return;
      if (nowEl && sel.dataset.total) nowEl.textContent = sel.dataset.total;
      if (wasEl) {
        var c = sel.dataset.compare;
        if (c) { wasEl.textContent = c; wasEl.hidden = false; }
        else { wasEl.hidden = true; }
      }
    }
    document.querySelectorAll('.forma-bd__card').forEach(function (c) { c.addEventListener('click', function () { setTimeout(syncPrice, 0); }); });
    syncPrice();
    var addBtn = bar.querySelector('[data-forma-satc-add]');
    if (addBtn) addBtn.addEventListener('click', function () {
      var sel = document.querySelector('.forma-bd__card.is-selected');
      var variant = (sel && sel.dataset.variant && sel.dataset.variant !== '0') ? sel.dataset.variant : '{{ v.id }}';
      addBtn.disabled = true;
      var addUrl = bar.getAttribute('data-cart-add-url') || '/cart/add.js';
      var checkoutUrl = bar.getAttribute('data-checkout-url') || '/checkout';
      fetch(addUrl, { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ id: parseInt(variant, 10), quantity: 1 }) })
        .then(function (r) { return r.json(); })
        .then(function () { window.location.href = checkoutUrl; })
        .catch(function () { addBtn.disabled = false; });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["forma-trustpilot"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var btn = document.querySelector('[data-forma-tp-more]');
    var list = document.querySelector('[data-forma-tp-list]');
    if(!btn || !list) return;
    var label = btn.querySelector('[data-more-label]');
    var moreText = label ? label.textContent : 'Show more';
    var lessText = btn.getAttribute('data-less') || 'Show less';
    btn.addEventListener('click', function(){
      var expanded = list.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if(label) label.textContent = expanded ? lessText : moreText;
      if(!expanded){ list.scrollIntoView({ behavior:'smooth', block:'start' }); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
